import React, { useMemo, useContext, useReducer, createContext } from "react";
import ApplicationReducer, { initialState as reducerInitialState } from "./reducer";
export const ApplicationContext = createContext();
export const initialState = {
  filtersReq: {
    quick_filter: [],
    preferred_Hotels: [],
    star_rating: [],
    customer_rating: [],
    property_amenities: [],
    property_theme: [],
    property_type: [],
    hotel_chain: [],
    room_amenities: [],
    price_slot: [],
    neighbourhood: [],
    price_range: { min: 0, max: 0 },
    hotelnamefilter: [],
    property_cancellation_options: [],
    stay_options: []
  }
};


export default function ApplicationProvider({ children }) {
  const [applicationState, setApplicationState] = useReducer(
    ApplicationReducer,
    initialState
  );
  const contextValue = useMemo(
    () => ({
      applicationState,
      setApplicationState,
    }),
    [applicationState, setApplicationState]
  );
  return (
    <ApplicationContext.Provider value={contextValue}>
      {children}
    </ApplicationContext.Provider>
  );
}
export const useApplicationContext = () => {
  const { applicationState } = useContext(ApplicationContext);
  return applicationState;
};
export const useApplicationDispatch = () => {
  const { setApplicationState } = useContext(ApplicationContext);
  return setApplicationState;
};
